<input
  class="fk-visually-hidden"
  type="radio"
  [id]="radioId"
  [formControl]="formControl"
  [name]="name"
  [value]="value"
>
<label [for]="radioId" class="control-radio">
  <div class="control-radio__icon"></div>
  <span *ngIf="label" class="control-radio__label fk-subtitle2 fk-ml2">{{ label }}</span>
  <span *ngIf="description" class="control-radio__description fk-paragraph2 fk-ml2">{{ description }}</span>
</label>

